import { Music } from "lucide-react";
import { ModuleHeader } from "./VideoCarousel";
import { resolveMedia } from "@/api/client";

// A simple audio sample player for the maha-mantra (or any track set in admin).
export const AudioSample = ({ module }) => (
  <div data-testid={`journey-audio-${module.id}`} className="mx-auto max-w-xl px-5 text-center">
    <ModuleHeader title={module.title} subtitle={module.subtitle} />
    <div className="mx-auto mt-8 max-w-md rounded-2xl border border-amber-200/15 bg-[#0d1226]/70 p-6">
      <div className="mb-4 grid place-items-center">
        <span className="grid h-14 w-14 place-items-center rounded-full bg-amber-400/15 text-amber-300">
          <Music className="h-6 w-6" />
        </span>
      </div>
      {module.src ? (
        <audio data-testid="audio-sample-player" controls src={resolveMedia(module.src)} className="w-full" />
      ) : (
        <p className="text-sm text-amber-50/50">An audio sample will appear here once added.</p>
      )}
    </div>
  </div>
);
